module.exports = __webpack_public_path__ + "static/media/globe.3a4a3ae4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/globe.svg
// module id = 415
// module chunks = 0